import { useState } from 'react'
import { useUpdatePreferencesMutation } from '../../store/api/usersApi'
import { STORAGE_KEYS, DEFAULT_THEME } from '../../lib/config'
import { Card } from '../../components/ui'
import s from '../../styles/pages/SettingsPage.module.css'

const THEMES = [
  { id: 'dark-purple', label: 'Dark Purple',   desc: 'Default dark theme',    preview: '#7c3aed' },
  { id: 'midnight',    label: 'Midnight Blue',  desc: 'Deep blue dark theme',  preview: '#2563eb' },
  { id: 'dark',        label: 'Pure Dark',      desc: 'Minimal black theme',   preview: '#6366f1' },
  { id: 'light',       label: 'Light',          desc: 'Clean light theme',     preview: '#7c3aed' },
  { id: 'solarized',   label: 'Solarized',      desc: 'Warm teal dark theme',  preview: '#2aa198' },
  { id: 'rose',        label: 'Rose',           desc: 'Deep rose dark theme',  preview: '#f43f5e' },
  { id: 'forest',      label: 'Forest',         desc: 'Deep green dark theme', preview: '#22c55e' },
  { id: 'ocean',       label: 'Ocean',          desc: 'Deep blue cyan theme',  preview: '#0ea5e9' },
]

export function SettingsAppearance() {
  const [updatePreferences] = useUpdatePreferencesMutation()
  const [currentTheme, setCurrentTheme] = useState(
    () => document.documentElement.getAttribute('data-theme') ?? DEFAULT_THEME
  )

  const applyTheme = (themeId: string) => {
    document.documentElement.setAttribute('data-theme', themeId)
    setCurrentTheme(themeId)
    localStorage.setItem(STORAGE_KEYS.theme, themeId)
    void updatePreferences({ theme: themeId }).catch(() => {})
  }

  return (
    <Card>
      <div className={s.themeTitle}>Theme</div>
      <div className={s.themeGrid}>
        {THEMES.map((theme) => (
          <button key={theme.id} onClick={() => applyTheme(theme.id)}
            className={`${s.themeBtn} ${currentTheme === theme.id ? s.active : ''}`}
            style={{ borderColor: currentTheme === theme.id ? theme.preview : undefined, background: currentTheme === theme.id ? theme.preview + '18' : undefined }}>
            <div className={s.themeBtnHeader}>
              <div className={s.themeColorDot} style={{ background: theme.preview }} />
              <div className={s.themeBtnLabel}>{theme.label}</div>
            </div>
            <div className={s.themeBtnDesc}>{theme.desc}</div>
            {currentTheme === theme.id && <div className={s.themeCheckmark} style={{ color: theme.preview }}>✓</div>}
          </button>
        ))}
      </div>
    </Card>
  )
}
